// Module
var code = `<div class="accordion amortization-accordion"
     ng-if="\$ctrl.ledger.entries">
  <table class="table">
    <thead>
      <tr>
        <td>Withholding tax</td>
        <td>{{\$ctrl.totalWithholdingTax | nxCurrency:'dashOnZero'}}</td>
      </tr>
      <tr>
        <th>No</th>
        <th>Accrual date</th>
        <th>No of days</th>
        <th>Amount</th>
        <th>Balance</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr ng-repeat="row in \$ctrl.ledger.entries track by \$index">
        <td>{{row.lineNumber}}</td>
        <td>{{row.accrualDate | prettyDate }}</td>
        <td>{{row.term}}</td>
        <td>{{row.interestAmount | nxCurrency:'dashOnZero'}}</td>
        <td>{{row.interestBalance | nxCurrency:'dashOnZero'}}</td>
        <td>{{row.status}}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td>{{\$ctrl.totalTerm}}</td>
        <td>{{\$ctrl.totalAdvanceInterest | nxCurrency:'dashOnZero'}}</td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/advance-interest/advance-interest-ledger.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;